import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  //PatchFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  FpxIHttpOption
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
import { CompName } from './compName.model';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';


@Injectable({
  providedIn: 'root',
})
export class CompNameService  implements BaseFpxDataService<any> {
  constructor(private _httpProvider : HttpProviderService,private process: ProcessShellService) {}

  findAll(): FindAllFn<any> {
    throw new Error('Method not implemented.');
  }
  create(payload: any): CreateFn<any> {
    throw new Error('Method not implemented.');
  }
  modify(payload: any): ModifyFn<any> {
    throw new Error('Method not implemented.');
  }

   findByKey(key: CompName,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindByKeyFn<CompName|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/compName/{id}/{code}');
       httpRequest.addPathParameter('id', key.id);
       httpRequest.addPathParameter('code', key.code);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest,httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.compName ?? null),catchError((err:any) => {
              return of(null)
            }));
      };
  }
  

 lookup(key: any,httpOption : Map<keyof FpxIHttpOption, Map<string, any>> = new Map(), criteriaQuery?: CriteriaQuery | undefined): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      let draftProcessInfo = this.process.getDraftProcessInfo();
      let applicationType;
      if(this.process.processCode == 'CARDORG') {
        applicationType = draftProcessInfo['ApplicantInfo']?.applicationtype;
        if(!applicationType) applicationType = this.process.processInfo?.processPayload[this.process.processCode]['ApplicantInfo'].applicationtype;
      } else if(this.process.processCode == 'SUPPLCARDORG') {
        applicationType = draftProcessInfo['supplApplicantInfo']?.applicationtype || draftProcessInfo['SupplApplicantInfo']?.applicationtype;
        if(!applicationType) applicationType = this.process.processInfo?.processPayload[this.process.processCode]['SupplApplicantInfo'].applicationtype;
      }
      if (applicationType != 'SBEC') {
        httpRequest.setResource('/compName');
      }else{
        httpRequest.setResource('/sbcgroup');
      }
      httpRequest.addQueryParameter('lookup', 1);
      if(!criteriaQuery) {
        criteriaQuery = new CriteriaQuery();
        criteriaQuery?.setPaginationCriteria("1", 50);
      }
      httpRequest.setCriteriaQuery(criteriaQuery);

      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
 

}
 

